import ZkForm from './src/form';

/* istanbul ignore next */
ZkForm.install = function(Vue) {
  Vue.component(ZkForm.name, ZkForm);
};

export default ZkForm;



// WEBPACK FOOTER //
// ./src/packages/form/index.js